"use strict";
import Account from "../api/account";
function isIndexerMode(location) {
  return isInMode("index", location);
}
function isAuditMode(location) {
  return isInMode("audit", location);
}
function factorInIndexerMode(location) {
  return Account.hasRole("Factor") && isIndexerMode(location);
}
function isInMode(mode_type, location) {
  if (!location) {
    return false;
  }
  const isIndexAuditSplitEnabled = !!Auth._currentUser.account.settings.index_audit_split_enabled;
  const onDone = location.query.onDone || "/dashboard";
  const inMode_ = new URLSearchParams(onDone).get("dashboardMode") === mode_type;
  return isIndexAuditSplitEnabled && inMode_;
}
export { isIndexerMode, isAuditMode, factorInIndexerMode };
